import { COMPANY_BROEMSE as SELECTED_COMPANY } from "../src/helpers/constants";
export const VERSION = '3.0.7.4';
export const PAST_DAYS = 10;
export const FUTURE_DAYS = 14;
export const WORK_DAYS = [1, 2, 3, 4, 5];
export const COMPANY = SELECTED_COMPANY;
